import { noop } from 'lodash-es'

import { LayerToggleOption } from './LayerManager.types'
import { LayerToggle } from './LayerToggle'

import styles from './LayerManager.module.css'

export type TasksLayerToggleProps = {
  value?: boolean
  onValueChange?: (value: boolean) => void
  childrenOptions?: LayerToggleOption[]
}

export const TasksLayerToggle = ({
  value = false,
  onValueChange = noop,
  childrenOptions = [],
}: TasksLayerToggleProps) => {
  return (
    <>
      <LayerToggle
        name="Tasks"
        value={value}
        setValue={onValueChange}
        testId="layer-manager-tasks-toggle"
      />
      {value ? (
        <div className={styles.childOptionsLayerToggleWrapper}>
          {childrenOptions.map((option) => (
            <LayerToggle key={option.name as string} {...option} />
          ))}
        </div>
      ) : null}
    </>
  )
}
